<template>
  <div class="pwc-app-wechat">
    <p v-if="showAlertInfoOpenInWechat">请在微信客户端打开链接</p>
  </div>
</template>

<script>
import { http } from '@/api'
import { Wechat } from '@/api/collection'
import { wechat } from '@/mixin/index'
import RouterName from '@/constants/route'

export default {
  mixins: [wechat],
  data() {
    return {
      showAlertInfoOpenInWechat: false
    }
  },
  async created() {
    if (!this.isWechat) {
      this.showAlertInfoOpenInWechat = true
      return
    }

    const code = await this.checkWechatBaseOAuthCode(false)
    if (!code) {
      return
    }

    const res = await http(
      {
        path: Wechat.GetWxUserForUrl.path,
        method: Wechat.GetWxUserForUrl.method,
        data: {
          code
        }
      }
    )
    if (Number(res.resultCode) === 0 && res.data && res.data.url) {
      localStorage.setItem('openId', res.data.openid || '')
      location.replace(`${decodeURIComponent(res.data.url)}&from_public=1`)
    } else {
      this.$router.replace({
        name: RouterName.login,
        query: { code: 'E5842473F0953D22', from_public: 1 }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-app-wechat {
  height: 100vh;
  padding-top: 20px;
  background-color: #e1e0de;
  font: 12px/18px "Lucida Grande", "Lucida Sans Unicode", Helvetica, Arial, Verdana, sans-serif;
  p {
    font-size: 16px;
    line-height: 1.3em;
    color: #000;
    text-align: center;
    font-weight: bold;
    text-shadow: 0px 1px 0px #efefed;
    margin: 0px;
  }
}
</style>
